import { ITrowelNavIcon } from "../../common/inerfaces/component-interfaces";
import "./index.scss";

const TrowelNavIcon: React.FC<ITrowelNavIcon> = ({
  menu: { label, src, width, height, path, isActive },
  onSelected,
}) => {
  const iconStyle = {
    backgroundImage: `url(${src})`,
    width,
    height,
  };
  return (
    <div
      className="trwl-nav-icon-wrapper"
      onClick={() => {
        onSelected({label, src, path, isActive});
      }}
    >
      <span className="nav-icon" style={iconStyle}></span>
      <span className={isActive ? "nav-text active-menu-item": "nav-text"}>{label}</span>
    </div>
  );
};

export default TrowelNavIcon;
